
const React = require("react")
const toast = require('react-hot-toast')
const config = require('./src/service/config')
const captcha = require('react-google-recaptcha-v3')

const { Toaster } = toast
const { GoogleReCaptchaProvider } = captcha
const { GATSBY_GOOGLE_RECAPTCHA_KEY } = config

const MobileReCaptchaToggle = () => {
    const [badge, setBadge] = React.useState(null)
    const [expanded, setExpanded] = React.useState(false)
    const toggleRef = React.useRef(null)

    React.useEffect(() => {
        const findBadge = () => {
            const element = document.querySelector('.grecaptcha-badge[data-style="bottomright"]')
            if (!element) return
            setBadge(element)
            observer.disconnect()
        }
        const observer = new MutationObserver(findBadge)
        observer.observe(document.body, { childList: true, subtree: true })
        findBadge()
        return () => observer.disconnect()
    }, [])

    React.useEffect(() => {
        if (!badge) return
        badge.classList.add("mobile-recaptcha-controlled")
        badge.classList.toggle("mobile-recaptcha-expanded", expanded)
        return () => {
            badge.classList.remove("mobile-recaptcha-controlled", "mobile-recaptcha-expanded")
        }
    }, [badge, expanded])

    React.useEffect(() => {
        if (!expanded) return
        const closeOnOutsideTap = (event) => {
            if (badge.contains(event.target) || toggleRef.current?.contains(event.target)) return
            setExpanded(false)
        }
        const closeOnEscape = (event) => {
            if (event.key === "Escape") setExpanded(false)
        }
        const closeOnScroll = () => {
            if (window.matchMedia("(max-width: 992px)").matches) setExpanded(false)
        }
        document.addEventListener("pointerdown", closeOnOutsideTap, true)
        document.addEventListener("keydown", closeOnEscape)
        const scrollEvents = ["scroll", "touchmove", "wheel"]
        scrollEvents.forEach(event => {
            window.addEventListener(event, closeOnScroll, { capture: true, passive: true })
        })
        return () => {
            document.removeEventListener("pointerdown", closeOnOutsideTap, true)
            document.removeEventListener("keydown", closeOnEscape)
            scrollEvents.forEach(event => window.removeEventListener(event, closeOnScroll, true))
        }
    }, [badge, expanded])

    if (!badge) return null

    return (
        <button
            ref={toggleRef}
            type="button"
            className={`mobile-recaptcha-toggle${expanded ? " is-expanded" : ""}`}
            aria-label={expanded ? "Collapse reCAPTCHA information" : "Expand reCAPTCHA information"}
            aria-expanded={expanded}
            onClick={() => setExpanded(value => !value)}
        />
    )
}

exports.wrapPageElement = ({ element, props }) => {
    return (
        <React.Fragment {...props}>
            <GoogleReCaptchaProvider reCaptchaKey={GATSBY_GOOGLE_RECAPTCHA_KEY}>
                {element}
                <MobileReCaptchaToggle />
                <Toaster
                    position="top-right"
                    toastOptions={{
                        duration: 3000
                    }}
                    success={{
                        duration: 2000,
                        theme: {
                            primary: 'green',
                            secondary: 'black',
                        }                    
                    }}
                />
            </GoogleReCaptchaProvider>
        </React.Fragment>
    )
  }

exports.shouldUpdateScroll = ({
    routerProps: { location },
    getSavedScrollPosition,
  }) => {
    window.scrollTo(0, 0)
    document.body.className = document.body.className.replace("body_fixed","");
    return false
  }